import { render, staticRenderFns } from "./ColumnChart.vue?vue&type=template&id=184b8c3f&scoped=true&lang=pug&"
import script from "./ColumnChart.vue?vue&type=script&lang=ts&"
export * from "./ColumnChart.vue?vue&type=script&lang=ts&"
import style0 from "./ColumnChart.vue?vue&type=style&index=0&id=184b8c3f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b8c3f",
  null
  
)

export default component.exports